<template>
  <div class="container_presentation" v-if="course.name">
    <div class="spacer"></div>
    <div class="spacer"></div>
    <b-container>
      <b-row>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/logo_rectangle_sm.png" alt="Logo challenge maritima" />
        </b-col>
        <b-col md="6">
          <h2 style="font-weight: bold">{{ course.name }} - {{ course.distance }}</h2>
          <h4>{{ course.date }} - Départ 9h30</h4>
        </b-col>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/Logo_TotalEnergies.png" alt="Logo Total energies" />
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="3" md="6">
          <div class="spacer"></div>

          <p>
            Course en nature, parcours idem que ceux de l'édition 2022. Les 4 premiers kilomètres sont communs, sur large chemin.<br />
            Ensuite les coureurs du 14km bifurquent pour une descente vers le chemin de fer puis regagnent le plateau, l'étang de l'estomac et passe par la montée du château d'eau pour revenir sur le Complexe Parsemain.<br />
            Divers : retraits des dossards, ravitaillement d'arrivée et récompenses dans la Salle Polyvalente du Complexe Parsemain.
          </p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <b-row>
        <b-col md="2"></b-col>
        <b-col md="4">
          <img src="@/assets/img/courses/YV5_5222.jpg" alt="" />
        </b-col>
        <b-col md="4">
          <img :src="'https://sportips.fr/challenge-maritima/img/flyer/' + course.url_flyer" alt="" />
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col>
          <p><b>Contact : fosolympique@gmail.com</b></p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <b-row>
        <b-col>
          <b-button class="infos_btn" download href="https://sportips.fr/challenge-maritima/uploads/COURSE_83292911.gpx">GPX de l'épreuve</b-button>
          <b-button class="infos_btn" href="http://fosolympiqueclub.fr" target="_blank">Infos course</b-button>
          <b-button class="infos_btn" download href="http://sportips.fr/challenge-maritima/uploads/reglement_draille.pdf">Réglement</b-button>
          <b-button class="infos_btn" href="http://courirenfrance.com" target="_blank">Inscriptions</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["course"],
  created() {},
};
</script>

<style lang="scss" scoped>
</style>